// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__20S1h","headline":"styles-m__headline__34sbf","related-story":"styles-m__related-story__LkLnx","stories-container":"styles-m__stories-container__1FUug"};